import { Component, OnInit, Optional } from '@angular/core';
import { ChooseFromNormativeDbService } from '@app/services';
import { ArhivPosjednik } from '@app/shared/models/arhiv-posjednik';
import { SaveItemViewService } from '@app/shared/services/save-item-view.service';
import { DynamicFormService } from '@ntap/common';
import {
  BackendUploadService,
  ItemProvider,
  ItemView,
  ItemViewProviderDirective,
  NotificationService,
  ViewWindow
} from '@ntap/core';
import { PrimeNGButtonSaveCloseItemActionComponent } from '@ntap/primeng';
import { combineLatest, concat, map, Observable } from 'rxjs';

@Component({
  selector: 'app-save-close-arhiv-posjednik',
  templateUrl: './save-close-arhiv-posjednik-action.html'
})
export class SaveCloseArhivPosjednikActionComponent
  extends PrimeNGButtonSaveCloseItemActionComponent
  implements OnInit
{
  chosenPersonChanged$: Observable<number>;

  constructor(
    @Optional() protected override window: ViewWindow,
    protected override itemProvider: ItemProvider,
    protected override itemViewProvider: ItemViewProviderDirective<ItemView>,
    protected override formService: DynamicFormService,
    protected override notificationService: NotificationService,
    protected override backendUploadService: BackendUploadService,
    protected chooseFromNormativeDbService: ChooseFromNormativeDbService,
    protected saveItemViewService: SaveItemViewService
  ) {
    super(
      window,
      itemProvider,
      itemViewProvider,
      formService,
      notificationService,
      backendUploadService
    );
  }

  public isDisabledWithChosen$: Observable<boolean>;

  ngOnInit() {
    const currentItemHasAgent$ = this.itemViewProvider.item$.pipe(
      map(
        (item: any) =>
          !!(item as ArhivPosjednik)[
            'en~arhiv_posjednik~agent_normativna_baza_id'
          ]
      )
    );
    const agentHasBeenChosen$ = this.chooseFromNormativeDbService.agentChosen$;
    this.isDisabledWithChosen$ = combineLatest([
      this.isDisabled$,
      concat(currentItemHasAgent$, agentHasBeenChosen$)
    ]).pipe(map(([disabled, chosen]) => disabled || !chosen));
  }
}
